import React from 'react';
import { isLpgProcurement } from '../../../../../../../shared/offer-domain/constants';
import OfferTableNonLpg from './nonLpg/OfferTableNonLpg';
import OfferTableLpg from './lpg/OfferTableLpg';

const OfferTable = ({
  viewMode = 'offer',
  alphaImprovementEditable = false,
  onAlphaImprovementChange,
  onImprovementMeta,
  ...props
}) => {
  if (isLpgProcurement(props.procurement)) {
    return (
      <OfferTableLpg
        viewMode={viewMode}
        alphaImprovementEditable={alphaImprovementEditable}
        onAlphaImprovementChange={onAlphaImprovementChange}
        onImprovementMeta={onImprovementMeta}
        {...props}
      />
    );
  }

  return (
    <OfferTableNonLpg
      viewMode={viewMode}
      alphaImprovementEditable={alphaImprovementEditable}
      onAlphaImprovementChange={onAlphaImprovementChange}
      onImprovementMeta={onImprovementMeta}
      {...props}
    />
  );
};

export default OfferTable;
